import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createCollection } from "../../api/apiCollections";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook to create a new collection
 */
export function useCreateCollection() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createCollectionMutate,
        isPending,
    } = useMutation({
        mutationFn: createCollection,
        onSuccess: (response) => {
            toast.success(response.message || "Collection created successfully");
            queryClient.invalidateQueries({ queryKey: ["collections"] });
            navigate('/collections');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create collection");
        },
    });

    return {
        createCollectionMutate,
        isPending,
    };
}
